import { settings } from '@alme/ui-web/settings/settings-util';
import * as conversation from '@alme/ui-web/ref/lib-alme-request';
import reduceReducers from 'reduce-reducers';
import { combineReducers } from 'redux';

function setupReducers(components, initialization){
    const reducers = {};
    // Use reduceReducers on history component reducers
    const initGetHistoryReducer = components.initializeGetHistory.getReducer();
    const historyAppenderReducer = components.historyAppender.getReducer();
    const endSessionReducer = components.endSessionRequestProcessor.getReducer();
    reducers.historyReducer = reduceReducers(initGetHistoryReducer, historyAppenderReducer, endSessionReducer);

    reducers.persistentStorageReducer = components.persistentStorage.getReducer();
    const persistenceReducer = components.persistenceStrategy.getReducer();

    // Get the reducers for the other components
    reducers.emptyReducer = (state={}) => { return state; };
    reducers.conversationReducer = reduceReducers(
        conversation.getReducer(),
        components.sessionManager.getReducer()
    );
  


    reducers.almeWindowReducer = components.almeWindow.getReducer();
    reducers.initializeReducer = initialization.getReducer();
    reducers.autoNavReducer = components.autoNavUrl.getReducer();
    reducers.welcomeUserReducer = components.welcomeUserAppevent.getReducer();
    reducers.clientCommunicatorReducer = components.clientCommunicator.getReducer();
    reducers.launchMessageProcessorReducer = components.launchMessageProcessor.getReducer();
    reducers.mobileDeviceDetector = components.mobileDeviceDetector.getReducer();
    reducers.commandActionReducer = components.commandActionHandler.getReducer();
    reducers.surveyReducer = components.feedbackOverlay.getReducer();
    reducers.stateTriggerer = components.stateTriggerer.getReducer();
    reducers.liveChatFoundationReducer = components.liveChatFoundation.getReducer();
    reducers.livechatReducer =reduceReducers(
        reducers.emptyReducer = (state={}) => { return state; }
    );
    // custom
    reducers.almeWindowReducer = components.almeWindow.getReducer();
    reducers.surveyReducer = components.feedbackOverlay.getReducer();
    reducers.formInteractionReducer = components.formInteractionHandler.getReducer();
    reducers.ttsReducer = components.ttsResponseHandler.getRealReducer();

    // Combine the reducers with combineReducers
    const rootReducer = combineReducers({
        [settings.stateLocations.Window.Base] : reducers.almeWindowReducer,
        [settings.stateLocations.Conversation.Base] : reducers.conversationReducer,
        [settings.stateLocations.History.Base] : reducers.historyReducer,
        [settings.stateLocations.PersistentStorage.Base] : reducers.persistentStorageReducer,
        [settings.stateLocations.AutoNav.Base] : reducers.autoNavReducer,
        [settings.stateLocations.WelcomeUser.Base] : reducers.welcomeUserReducer,
        [settings.stateLocations.ClientCommunicator.Base] : reducers.clientCommunicatorReducer,
        [settings.stateLocations.Initialization.Base] : reducers.emptyReducer,
        [settings.stateLocations.DeviceType]: reducers.mobileDeviceDetector,
        [settings.stateLocations.CommandAction.Base]: reducers.commandActionReducer,
        [settings.stateLocations.Survey.Base]: reducers.surveyReducer,
        [settings.stateLocations.FormInteraction.Base] : reducers.formInteractionReducer,
        [settings.stateLocations.TTS.Base] : reducers.ttsReducer,
        [settings.stateLocations.CommandAction.Base] : reducers.commandActionReducer,
        [settings.stateLocations.LiveChat.Base]: reducers.emptyReducer,
    });

    return reduceReducers(rootReducer, persistenceReducer, reducers.initializeReducer, 
        reducers.launchMessageProcessorReducer, reducers.stateTriggerer,reducers.liveChatFoundationReducer,reducers.livechatReducer
        );
}

export {
    setupReducers
};



// WEBPACK FOOTER //
// ./src/setup-reducers.js